import { partial, pick } from 'lodash/fp'

import { ListState } from '../interfaces'

export const pickListState = partial(pick, [['page', 'pageSize', 'sort', 'filters']]) as <T extends ListState>(
  // eslint-disable-next-line no-use-before-define
  state: T
) => ListState
